import { Component, ViewEncapsulation, OnInit, HostListener } from '@angular/core';
import { SelfAttendanceService } from '../../shared/services/self-attendance.service';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionStorageService } from "../../shared/services/session-storage.service";
import { DtmService } from 'src/app/services/dtm.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Dtm, Rules, getDtm, getNameMapping } from '../../shared/enum/dtm';
import { authReasonCode, getCancelContractDataError, handleIntegrationError } from '../../shared/constants/errors';
import { environment } from 'src/environments/environment';

export enum Mapping {
  'saude-do-seu-negocio' = 'SaudeFinanceira',
  'consulta-e-recuperacao-de-dividas' = 'CS-RDD',
  'monitore-clientes' = 'Serasa Monitora',
  'lista-online' = 'Prospeccao',
  'plano-mensal' = "Assinatura",
  'plano-mensal-recarga-pontual' = "AssinaturaRecargaPontual",
  'descomplica' = "Descomplica"
}

@Component({
    selector: 'pme-retention-policy',
    templateUrl: './retention-policy.component.html',
    styleUrls: ['./retention-policy.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RetentionPolicyComponent implements OnInit {
  isRetentionApplicable: boolean;
  retetionMessage: boolean;
  retetionOfferPlan: string;
  retetionOfferDiscount: number;
  showRetention: boolean = false;
  showRetentionBenefits: boolean = false;
  showRetentionDiscount: boolean = false;
  isRetentionStepCompleted: boolean = false;
  proceededWithCancellation: boolean;

  reasonForCancellation: string;
  classificationIdentifier: string;
  planIdentifier: string;
  planName: string;
  planType: string;
  value: string;
  productValue: number;
  productValueWithDiscount: any;
  offerPlan: string;
  offerDiscount: { identifier: string; id: string } = { identifier: '', id: '' };
  benefits: { title: string; description: string; iconUrl: string }[] = [];
  paymentMethod: string;
  cancelReason: string;
  selectedOption: string;
  cancelMessage: any;

  isMobile: boolean = window.innerWidth < 960;
  showForm: boolean = false;
  showHero: boolean;
  pageLoadEventSent: boolean = false;

  cancellationForm: UntypedFormGroup;
  cancelFormErrors: Array<string> = [];
  submitting: boolean = false;
  hasScheduleCancelDate: boolean = false;
  cancelBuyIntention: boolean = false;
  cancelContractId: string;

  businessId: string;
  userId: string;
  startDate: string;
  endDate: string;
  days: number;
  accountBankData: any = {};
  heroData: any = {};
  errorResponse: any;
  redirectUrl: string;
  isActiveTrial: boolean;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public dtmService: DtmService,
    private utils: UtilsService,
    private selfAttendanceService: SelfAttendanceService,
    public sessionStorageService: SessionStorageService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
  ) {
    this.classificationIdentifier = this.sessionStorageService.getClassification(this.route);

    this.getProvisioningParametersFromSessionStorage();
  }

  ngOnInit() {
    this.openDialogSpinner();

    this.selfAttendanceService.getConfigByPlan(this.planIdentifier, this.userId, this.businessId).subscribe(
      (configPlanData) => {
        if (configPlanData.benefits && configPlanData.benefits.length > 0) {
          // Adobe Analytics - Padronizacao Setembro/2020
          this.sendCustomPageViewEvent(Dtm.Rentencao);
          this.showRetention = true;
          this.showRetentionBenefits = true;
          this.benefits = configPlanData.benefits.map(benefit => ({
            title: benefit.title,
            description: benefit.description,
            iconUrl: benefit.iconUrl
          }));
        }else {
          this.cancelPlan(true);
          return;
        }

        this.isRetentionApplicable = configPlanData.isApplicable;

        if(this.isRetentionApplicable) {
          this.offerDiscount = {
            identifier: configPlanData.offerDiscount.identifier,
            id: configPlanData.offerDiscount._id
          };

          this.cancelContractId = configPlanData.contract.id;
          this.productValue = configPlanData.contract.productValue;
          this.productValueWithDiscount = configPlanData.contract.productValueWithDiscount;

          this.retetionMessage = configPlanData.message;
        }

        this.setDisclaimer(this.days, this.endDate);

        // Adobe Analytics - Padronizacao Setembro/2020
        this.sendCustomPageViewEvent(Dtm.Rentencao);

        this.closeDialogSpinner();
      },
      (error) => {
        this.showCustomError('getCancelContractDataError', error);
      }
    );
  }




  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    this.isMobile = window.innerWidth < 960;
  }

  cancelPlan(outRetention?: boolean) {
    this.openDialogSpinner();

    if (this.submitting) {
      return;
    }

    this.submitting = true;
    if (this.isRetentionApplicable) {
      if (!this.isRetentionStepCompleted) {
        this.showRetentionBenefits = false;
        this.showRetentionDiscount = true;
        this.isRetentionStepCompleted = true;
        this.submitting = false;
        this.dtmService.customClickEvent(`AutoAtendimento: ${getNameMapping(this.classificationIdentifier)} :Retencao:ConfirmarCancelamento`);
        this.dtmService.customLoaded(["CustomImpression"], null, null, {itemImpression:"IMP:MEMEI:Sydle:AutoAtendimento:" + this.classificationIdentifier + ":Retencao:" + this.offerDiscount.identifier});
        this.dtmService.sendPageLoadEvent("CustomImpression");
        this.closeDialogSpinner();
        return;
      } else {
        this.proceededWithCancellation = true;
        this.selfAttendanceService.setRetentionWasDisplayed(this.planIdentifier, this.userId, this.businessId, this.proceededWithCancellation, this.reasonForCancellation)
        .subscribe();

        this.dtmService.pageLoaded(Dtm.Rentencao, true, getDtm(Dtm.Rentencao, this.classificationIdentifier));
        this.dtmService.customClickEvent(`AutoAtendimento: ${getNameMapping(this.classificationIdentifier)} :RetencaoDesconto:ConfirmarCancelamento`);
      }
    }

    if(!this.isRetentionApplicable && this.showRetentionBenefits) this.dtmService.customClickEvent(`AutoAtendimento: ${getNameMapping(this.classificationIdentifier)} :Retencao:ConfirmarCancelamento`);
    const timeStamp = new Date().toISOString();
    this.selfAttendanceService.cancelContract(
      this.businessId, this.userId, this.selectedOption,
      this.cancelMessage, this.accountBankData, this.classificationIdentifier, timeStamp
    ).subscribe(
      (selfAttendanceData) => {
        if (selfAttendanceData && selfAttendanceData.result) {
          selfAttendanceData.businessId = this.businessId;
          selfAttendanceData.userId = this.userId;

          // Adobe Analytics
          this.dtmService.customCancellation(['CancelarPlano'], this.selectedOption, selfAttendanceData.refund);
          this.dtmService.productsLoaded([{
            identifier: this.planIdentifier,
            classificationName: selfAttendanceData.contract.product.classificationName
          }]);
          this.dtmService.ruleChange(Rules.CancelarPlano);
          this.dtmService.sendCancellationEvent();
          this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
          this.closeDialogSpinner();
          this.router.navigate(['../../sucesso'], {relativeTo: this.route});
      }
      },
      (error) => {
        this.showCustomError('cancelContractError', error);
        this.utils.createAdobeAnalyticsLog(
          'cancelContract',
          JSON.stringify(error),
          JSON.stringify({
            'businessId': this.businessId,
            'userId': this.userId,
            'reason': this.selectedOption,
            'message': this.cancelMessage,
            'accountBankData': this.accountBankData,
            'productClassification': this.classificationIdentifier,
            'timeStamp': timeStamp
          })
        ).subscribe();
        this.closeDialogSpinner();
      }
    );
  }

  continuePlan() {
    this.openDialogSpinner();

    if (this.showRetentionDiscount) {
      this.dtmService.customClickEvent(`AutoAtendimento: ${getNameMapping(this.classificationIdentifier)} :RetencaoDesconto:ConfirmarRetencao`);
      this.proceededWithCancellation = false;

      this.selfAttendanceService.setRetentionWasDisplayed(this.planIdentifier, this.userId, this.businessId, this.proceededWithCancellation, this.reasonForCancellation).
      toPromise()
      .then(() => {
        this.selfAttendanceService.renewPlanWithDiscount(this.cancelContractId, this.offerDiscount.id)
          .subscribe(
            (selfAttendanceData) => {
              if (selfAttendanceData && selfAttendanceData.result) {
                selfAttendanceData.businessId = this.businessId;
                selfAttendanceData.userId = this.userId;

                this.dtmService.customRetention(['RetencaoSucesso'], this.selectedOption);
                this.dtmService.productsLoaded([{
                  identifier: this.planIdentifier,
                  classificationName: selfAttendanceData.contract.product.classificationName
                }]);
                this.dtmService.ruleChange(Rules.RetencaoSucesso);
                this.dtmService.sendRetentionEvent();
                this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
                this.closeDialogSpinner();
                this.router.navigate(['../../sucesso'], {relativeTo: this.route});
              }
            },
            (error) => {
              this.showCustomError('renewPlanWithDiscountError', error);
              this.closeDialogSpinner();
            }
          );
      })
      .catch((error) => {
        this.showCustomError('setRetentionWasDisplayedError', error);
        this.closeDialogSpinner();
      });
    } else {
      this.dtmService.customClickEvent(`AutoAtendimento: ${getNameMapping(this.classificationIdentifier)} :Retencao:ConfirmarRetencao`);
      window.location.href = environment.serasaHomePage || this.redirectUrl;
      this.closeDialogSpinner();
    }
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: "400px",
      panelClass: "pme-dialog-loading-panel",
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  closeDialogSpinner(): void {
    this.dialog.closeAll();
  }

  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;
    switch (customErrorKey) {
        case 'authenticationError':
            if (this.hasScheduleCancelDate) {
                integrationErrorMessage = this.showCustomHeroError(integrationError, 'scheduleCancelDataError');
            } else if (this.cancelBuyIntention) {
                integrationErrorMessage = this.showCustomHeroError(integrationError, 'cancelBuyIntention');
            } else {
                integrationErrorMessage = this.showCustomHeroError(integrationError, 'authenticationError');
            }

            console.error(integrationErrorMessage);

            // Analytics
            this.dtmService.customErrorLoaded(["error"], {
                errorDetail: integrationErrorMessage.errorString,
                errorMessage: integrationErrorMessage.userMessage,
            });
            break;
        case 'getCancelContractDataError':
            if (this.hasScheduleCancelDate) {
                integrationErrorMessage = this.showCustomHeroError(integrationError, 'scheduleCancelDataError');
            } else if (this.cancelBuyIntention) {
                integrationErrorMessage = this.showCustomHeroError(integrationError, 'cancelBuyIntention');
            } else {
                integrationErrorMessage = this.showCustomHeroError(integrationError, 'getCancelContractDataError');
            }

            console.error(integrationErrorMessage);

            // Analytics
            this.dtmService.customErrorLoaded(["error"], {
                errorDetail: integrationErrorMessage.errorString,
                errorMessage: integrationErrorMessage.userMessage,
            });
            break;
        case 'cancelContractError':
            integrationErrorMessage = handleIntegrationError(integrationError);

            console.error(integrationErrorMessage);

            this.cancelFormErrors.push(integrationErrorMessage.userMessage);

            // Analytics
            this.dtmService.customErrorLoaded(["error"], {
                errorDetail: integrationErrorMessage.errorString,
                errorMessage: integrationErrorMessage.userMessage,
            });
            break;
        case 'renewPlanWithDiscountError':
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'renewPlanWithDiscountError');

            console.error(integrationErrorMessage);

            // Analytics
            this.dtmService.customErrorLoaded(["error"], {
                errorDetail: integrationErrorMessage.errorString,
                errorMessage: integrationErrorMessage.userMessage,
            });
            break;
        case 'setRetentionWasDisplayedError':
            integrationErrorMessage = this.showCustomHeroError(integrationError, 'setRetentionWasDisplayedError');

            console.error(integrationErrorMessage);

            // Analytics
            this.dtmService.customErrorLoaded(["error"], {
                errorDetail: integrationErrorMessage.errorString,
                errorMessage: integrationErrorMessage.userMessage,
            });
            break;
        default:
            break;
    }

    this.closeDialogSpinner();
    if (this.showForm) {
        this.submitting = false;
    }
  }

  showCustomHeroError(error, type) {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        // Nova errorString
        resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

        //resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;

        resultError.userMessage = error.error._messages[0].text;
        resultError.code = error.error._messages[0].code;

        switch (type) {
          case 'authenticationError':
            if (authReasonCode[resultError.code]) {
              this.heroData.type = authReasonCode[resultError.code].type || 'error';
              this.heroData.title = authReasonCode[resultError.code].title;
              this.heroData.contents = authReasonCode[resultError.code].contents;
            } else {
              this.heroData.type = 'error';
              this.heroData.title = 'Serviço indisponível!';
              this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            }
            break;
          case 'getCancelContractDataError':
            if (getCancelContractDataError[resultError.code]) {
              this.heroData.type = 'error';
              this.heroData.title = getCancelContractDataError[resultError.code].title;
              this.heroData.contents = getCancelContractDataError[resultError.code].contents;
            } else {
              this.heroData.type = 'error';
              this.heroData.title = 'Serviço indisponível!';
              this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            }
            break;
          case 'scheduleCancelDataError':
            if (getCancelContractDataError[resultError.code]) {
              this.heroData.type = 'success';
              this.heroData.title = getCancelContractDataError[resultError.code].title;
              this.heroData.contents = ["A assinatura que estava com o cancelamento agendado foi reativada. Sua próxima renovação será em " + this.formatDate(this.errorResponse.nextRecurrenceDate) + "."];
            } else {
              this.heroData.type = 'error';
              this.heroData.title = 'Serviço indisponível!';
              this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            }
            break;
          case 'cancelBuyIntention':
              if (getCancelContractDataError[resultError.code]) {
                this.heroData.type = 'success';
                this.heroData.title = getCancelContractDataError[resultError.code].title;
                this.heroData.contents = ['Desconsidere o ' + this.errorResponse.paymentMethod + ' emitido para o ' + this.errorResponse.productName + " com vencimento em " + this.formatDate(this.errorResponse.expirationDateInvoice) + "."];
              } else {
                this.heroData.type = 'error';
                this.heroData.title = 'Serviço indisponível!';
                this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
              }
              break;
          default:
            this.heroData.type = 'error';
            this.heroData.title = 'Serviço indisponível!';
            this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
            break;
        }
      }
    } catch (e) {
      console.error(e);
      resultError.errorString = JSON.stringify(error);
      this.heroData.type = 'error';
      this.heroData.title = 'Serviço indisponível!';
      this.heroData.contents = ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
    }

    this.heroData.showButton = true;
    this.heroData.buttonName = 'Ir para área logada';
    this.heroData.redirectURL =  environment.serasaHomePage || this.redirectUrl;
    this.showHero = true;
    return resultError;
  }

  formatDate(date){
    let scheduleDate = new Date(new Date(date).getTime() + 3*60*60*1000);
    let formatedDate = "";
    scheduleDate.getDate() + "/" + (scheduleDate.getUTCMonth()+1) + "/" + scheduleDate.getUTCFullYear()

    if(scheduleDate.getDate() < 10){
      formatedDate += "0" + scheduleDate.getDate();
    } else {
      formatedDate += scheduleDate.getDate();
    }

    formatedDate += "/";

    if((scheduleDate.getUTCMonth()+1) < 10){
      formatedDate += "0" +  (scheduleDate.getUTCMonth()+1);
    } else {
      formatedDate += (scheduleDate.getUTCMonth()+1);
    }

    formatedDate += "/";

    formatedDate += scheduleDate.getUTCFullYear();

    return formatedDate;
  }

  setDisclaimer(days, endDate){
    this.showHero = true;
    if(this.isActiveTrial){
        this.heroData.type = 'warn';
        this.heroData.title = 'Cancelamento de plano';
        this.heroData.contents = ['Sua assinatura será cancelada imediatamente e não será cobrado nenhum valor referente ao período de teste no seu cartão cadastrado.']
    }else if (days > 7) {
        this.heroData.type = 'warn';
        this.heroData.title = 'Cancelamento de plano';
        this.heroData.contents = ['Você continuará com o seu plano até '+ endDate + ' e cancelaremos todas as cobranças futuras.']
    }else{
      this.heroData.type = 'warn';
      this.heroData.title = 'Cancelamento de plano';
      this.heroData.contents = ['Sua assinatura será cancelada imediatamente e faremos a devolução integral do valor pago.']
    }
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();
    this.redirectUrl = sessionStorage.getItem('redirectUrl');

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }

    this.selectedOption  = sessionStorage.getItem('cancelReasonOption');
    this.cancelReason = sessionStorage.getItem('cancelReason');
    this.cancelMessage  = sessionStorage.getItem('cancelMessage');

    if (this.cancelMessage !== 'undefined' && this.cancelMessage !== null && this.cancelMessage.trim() !== '') {
      this.reasonForCancellation = this.cancelReason + ' - ' + this.cancelMessage;
    } else {
      this.reasonForCancellation = this.cancelReason;
    }

    const cancelContract = sessionStorage.getItem('cancelData');

    if (cancelContract) {
      const cancelData = JSON.parse(cancelContract);

      this.showForm = true;
      this.startDate = cancelData.startDate;
      this.planIdentifier = cancelData.planIdentifier;
      this.planName = cancelData.planName;
      this.value = cancelData.value;
      this.days = cancelData.days;
      this.paymentMethod = cancelData.paymentMethod;
      this.endDate = cancelData.endDate;
      this.isActiveTrial = cancelData.isActiveTrial;
    }
  }

  getPlanType() {
    const parts = this.planName.split('- ');
    let type;

    switch (this.classificationIdentifier) {
      case 'saude-do-seu-negocio':
        type = parts[1].split(' ')[0];
        break;
      case 'monitore-clientes':
      case 'plano-mensal':
        type = parts[1].split(' ')[1];
        break;
      default:
        return 'assinatura';
    }

    return type;
  }

  mapIdentifier(identifier: string): string {
    if (identifier in Mapping) {
      return Mapping[identifier as keyof typeof Mapping];
    }

    return identifier;
  }

  sendCustomPageViewEvent(dtm:Dtm) {
    this.dtmService.customLoaded([ ]);
    this.dtmService.pageLoaded(dtm, true, getDtm(dtm, this.classificationIdentifier));
    this.dtmService.sendPageLoadEvent();
  }
}
